"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const formTypes_1 = require("../forms/utils/formTypes");
const ebookUpsert_1 = require("../forms/upsert/ebookUpsert");
const webinarUpsert_1 = require("../forms/upsert/webinarUpsert");
const additionalFunctions_1 = require("./additionalFunctions");
const heroFormUpsert_1 = require("../forms/upsert/heroFormUpsert");
const meetupUpsert_1 = require("../forms/upsert/meetupUpsert");
class PostFunctions extends additionalFunctions_1.AdditionalFunctions {
    constructor(rootUrl, registerEnv) {
        super(rootUrl);
        this.getPostAttribute = (form) => {
            if (form.hasAttribute("data-action")) {
                const formType = form.getAttribute("data-action");
                switch (formType) {
                    case formTypes_1.formTypes.hero_form:
                    case formTypes_1.formTypes.hero_form_it:
                    case formTypes_1.formTypes.hero_form_de:
                    case formTypes_1.formTypes.hero_form_es:
                        (0, heroFormUpsert_1.heroFormUpsert)(form, this.additionalMethods.renderMessageInfo);
                        break;
                    case formTypes_1.formTypes.ebook:
                        (0, ebookUpsert_1.ebookUpsert)(form, this.additionalMethods.renderMessageInfo);
                        break;
                    case formTypes_1.formTypes.webinar:
                    case formTypes_1.formTypes.webinar_es:
                    case formTypes_1.formTypes.webinar_it:
                        (0, webinarUpsert_1.webinarUpsert)(form, this.additionalMethods.renderMessageInfo);
                        break;
                    case formTypes_1.formTypes.meetup:
                        (0, meetupUpsert_1.meetupUpsert)(form, this.additionalMethods.renderMessageInfo);
                        break;
                    default:
                        break;
                }
            }
        };
        this.url = rootUrl;
        this.registerEnv = registerEnv;
        this.additionalMethods = {
            renderMessageInfo: this.renderMessageInfo.bind(this),
            getRegisterEnv: this.getRegisterEnv.bind(this),
        };
    }
}
exports.default = PostFunctions;
